<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="addBtn">新增</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);margin: 0 20px;overflow-y: auto">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="sampleno"
          label="编号"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="operator"
          label="操作人"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="留样图片"
          min-width="90"
          align="center">
          <template slot-scope="scope">
            <img style="height: 100px" v-for="item in scope.row.pictureArr" :key="item.index" :src="item.url">
          </template>
        </el-table-column>
        <el-table-column
          prop="sampleday"
          label="时间"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="vendor"
          label="供应商"
          min-width="80"
          align="center">
        </el-table-column>
<!--        <el-table-column-->
<!--          label="食材供应商"-->
<!--          min-width="90"-->
<!--          align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{getVendorName(scope.row.vendorid)}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          label="餐厅"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getRestaurantName(scope.row.restaurantid)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <i title="查看" class="el-icon-view" style="cursor: pointer; font-size: 18px;color: blue" @click="seeBtn(scope.row)"></i>
<!--            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>-->
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{addEditTitle}}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-sample :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-sample>
    </el-dialog>
  </div>
</template>

<script>
import {queryrestaurant, queryfoodsample, queryingredientvendor, deletefoodsample} from '../../api/yanglaoyuan'
import {getToken} from '../../utils/auth'
import addEditSample from './components/addEditSample'
export default {
  name: 'foodEvidence',
  components: {addEditSample},
  data () {
    return {
      token: '',
      restaurants: [], // 餐厅
      ingredientvendors: [], // 食材供应商
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        restaurants: [], // 餐厅
        ingredientvendors: [], // 食材供应商
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
    this.token = getToken()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getRestaurants()
  },
  methods: {
    // 餐厅
    getRestaurants () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.restaurants = res.data.restaurants
        this.addEditObj.restaurants = res.data.restaurants
        this.getIngredientVendorsData()
      })
    },
    // 供应商
    getIngredientVendorsData () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryingredientvendor(params, data).then(res => {
        this.ingredientvendors = res.data.ingredientvendors
        this.addEditObj.ingredientvendors = res.data.ingredientvendors
        this.getTableData()
      })
    },
    getTableData () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId
      }
      queryfoodsample(params, data).then(res => {
        // this.tableData = res.data.foodsamples
        let table = []
        let arr = res.data.foodsamples
        for (let i = 0; i < arr.length; i++) {
          let obj = arr[i]
          obj.pictureArr = this.getImgUrls(obj.pictures)
          table.push(obj)
        }
        this.tableData = table
        this.totalCells = res.data.cnt
      })
    },
    getImgUrls (picture) {
      let url = this.commonType.getapi() + 'food/image/'
      let list = []
      let arr = picture.split(',')
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          let photoUrl = url + arr[i] + '?token=' + getToken()
          let obj = {
            filename: arr[i],
            url: photoUrl
          }
          list.push(obj)
        }
      }
      return list
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    getVendorName (id) {
      let name = id
      for (let i = 0; i < this.ingredientvendors.length; i++) {
        if (id === this.ingredientvendors[i].id) {
          name = this.ingredientvendors[i].name
        }
      }
      return name
    },
    addBtn () {
      this.addEditTitle = '新增留样'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    seeBtn (row) {
      this.addEditTitle = '查看留样'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑留样'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该留样【' + row.sampleno + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletefoodsample(data).then(res => {
          this.$notify({title: '成功', message: '成功删除食材', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getTableData()
        })
      })
    },
    updateTable () {
      this.getTableData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/foodEvidence.vue